module.exports = __webpack_public_path__ + "img/41.e4747458.svg";